import { createClient } from '@supabase/supabase-js';

// Supabase configuration — loaded from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

// Database table names
export const TABLES = {
  LEADS: 'leads',
  LEAD_EVENTS: 'lead_events',
  CONTACT_DETAILS: 'contact_details',
  CONVERSATIONS: 'conversations',
  MESSAGES: 'messages',
  MEETINGS: 'meetings',
  BOOKING_STATUS: 'booking_status',
  BOOKING_MANAGEMENT: 'booking_management',
  NOTES: 'notes',
  TASKS: 'tasks',
  EMAIL_AUTOMATION_TEMPLATES: 'email_automation_templates',
  EMAIL_AUTOMATION_EXECUTIONS: 'email_automation_executions',
  EMAIL_AUTOMATION_SETTINGS: 'email_automation_settings',
  // RBAC tables
  USERS_ROLES: 'users_roles',
  RBAC_AUDIT_LOG: 'rbac_audit_log',
  // Signal Engine tables
  SIGNAL_PROFILES: 'signal_profiles',
  RAW_SIGNALS: 'raw_signals',
  SCORED_SIGNALS: 'scored_signals',
  SCORED_SIGNAL_SOURCES: 'scored_signal_sources',
  SIGNAL_API_USAGE: 'signal_api_usage',
  // Country Pack Intelligence tables
  COUNTRY_SOURCE_REGISTRY: 'country_source_registry',
  SIGNAL_INTELLIGENCE_REPORTS: 'signal_intelligence_reports',
  // Web Tracking tables
  TRACKED_SITES: 'tracked_sites',
  TRACKED_SITE_USERS: 'tracked_site_users',
  WEB_TRACKING_TOKENS: 'web_tracking_tokens',
  WEB_VISITS: 'web_visits'
};

// Lead status constants
export const LEAD_STATUS = {
  NEW: 'new',
  INTERESTED: 'interested',
  CALL_LIST: 'call_list',
  ARCHIVED: 'archived'
};

// Event types
export const EVENT_TYPES = {
  OPEN: 'open',
  CLICK: 'click',
  REPLY: 'reply',
  BOUNCE: 'bounce',
  UNSUBSCRIBE: 'unsubscribe',
  WEB_VISIT: 'web_visit'
};

// Score thresholds
export const SCORE_THRESHOLDS = {
  CALL_LIST: 20,
  HIGH_PRIORITY: 15,
  MEDIUM_PRIORITY: 10
};